import { useMutation } from "@tanstack/react-query";
import {
  onboardingFormChatRepository,
  type OnboardingFormChatMessageRequest,
} from "../repositories/onboardingFormChat.repository";

export const useOnboardingFormChatMutation = () =>
  useMutation({
    mutationFn: (payload: OnboardingFormChatMessageRequest) =>
      onboardingFormChatRepository.sendMessage(payload),
  });
